/**
 * Which tool the board is currently in.
 *
 * `select` is the default: clicks select objects. The other tools are
 * one-shot — after a successful placement the board snaps back to `select`
 * (wired up starting in M4 when the first placeable tool ships).
 */
export type Tool = 'select' | 'text' | 'line' | 'sticky' | 'checkbox' | 'person' | 'rectangle' | 'ellipse' | 'smiley';

export const TOOL_CHANGED_EVENT = 'tool-changed' as const;

export interface ToolChangedDetail {
  tool: Tool;
  /** Only present when tool === 'smiley' — the emoji that will be placed. */
  emoji?: string;
}
